import arrowToTicket from "./icons/arrow/arrow_to_ticket.svg";
import calendarWithArrow from "./icons/calendar/calendar_arrow.svg";
import calendarWithPlus from "./icons/calendar/calendar_plus.svg";
import dollar from './icons/dollar/dollar.svg';
import place from "./icons/place/place.svg";
import ticket from './icons/ticket/ticket.svg'
import userDark from './icons/user/user_dark.svg';

import newTicket from './icons/ticket/newTicket.svg'

import materialCalendar from './icons/calendar/material_calendar.svg'

import leftArrow from './icons/leftArrow/leftArrow.svg'

import checkin from './icons/event-toolbar/checkin.svg'
import dashboard from './icons/event-toolbar/dashboard.svg';
import sell from './icons/event-toolbar/sell.svg'
import settings from './icons/event-toolbar/settings.svg'

import rupee from './icons/rupee/rupee-indian.svg'

export default {
  arrow: {
    toTicket: arrowToTicket
  },
  place,
  userDark,
  calendar: {
    withArrow: calendarWithArrow,
    withPlus: calendarWithPlus
  },
  ticket,
  newTicket,
  dollar,
  rupee,
  leftArrow,
  materialCalendar,
  dashboard,
  sell,
  checkin,
  settings
};





// WEBPACK FOOTER //
// ./src/assets/Icons.tsx